
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { X, Menu } from "lucide-react";
import Marquee from "react-fast-marquee";
import { useWebData } from "../../Context/webDataContext";
import { FaArrowRight } from "react-icons/fa";

const defaultNavbarData = {
  notificationContent: "New Features, Now Live! Download Now",
  notificationContentUrl: "/",
  content: [
    { item: "About", section: "about" },
    { item: "Services", section: "services" },
    { item: "Contact", href: "/contact" },
    { item: "How It Works", section: "about" },
    { item: "For Service Providers", section: "services" },
    { item: "FAQs", section: "faqs" },
    { item: "Contact Us", href: "/contact" },
    { item: "Blogs", href: "/blogs" },
  ],
};

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { getNavbarData } = useWebData();
  const [navbarData, setNavbarData] = useState(defaultNavbarData);

  useEffect(() => {
    const fetchNavbarData = async () => {
      try {
        const data = await getNavbarData();
        if (data) {
          const navbarKey = Object.keys(data)[0];
          setNavbarData(data[navbarKey]);
        }
      } catch (error) {
        console.error("Error fetching navbar data:", error);
      }
    };

    fetchNavbarData();
  }, [getNavbarData]);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const handleNavLinkClick = (href, section) => {
    if (href) {
      navigate(href.startsWith("http") ? href : `/${href}`);
    } else if (section) {
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => {
          document
            .getElementById(section)
            ?.scrollIntoView({ behavior: "smooth" });
        }, 1000);
      } else {
        document
          .getElementById(section)
          ?.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/");
    }
    closeMobileMenu();
  };

  return (
    <nav className="w-full bg-white fixed md:static top-0 left-0 z-50">
      <Marquee
        speed={50}
        className="md:p-4 p-2 text-center lato text-white fixed top-0"
        style={{
          background:
            "linear-gradient(180deg, #1D9D67 0%, #1E8157 35.45%, #1F6546 83.28%)",
        }}
      >
        <Link
          to={navbarData.notificationContentUrl}
          className="md:text-lg text-sm font-medium cursor-pointer flex items-center gap-1"
        >
          <span>{navbarData.notificationContent}</span>
          <span className="mt-1">
            <FaArrowRight />
          </span>
        </Link>
      </Marquee>

      <div className="px-4 lg:px-20 lg:pt-5 py-2 flex items-center justify-between">
        <Link to="/" className="text-2xl text-[#08875D] font-extrabold">
          maid<span className="text-[#FC0]">eaze</span>
        </Link>

        <ul className="hidden lg:flex space-x-6">
          {navbarData.content.map(({ item, href, section }, index) => (
            <li key={index}>
              <button
                onClick={() => handleNavLinkClick(href, section)}
                className="text-gray-700 hover:text-green-700 text-base font-medium hover:font-bold transition-all"
              >
                {item}
              </button>
            </li>
          ))}
        </ul>

        <button
          onClick={toggleMobileMenu}
          className="lg:hidden z-50 focus:outline-none"
          aria-label="Toggle Menu"
        >
          {isMobileMenuOpen ? <X size={1} /> : <Menu size={26} />}
        </button>

        {isMobileMenuOpen && (
          <div className="fixed inset-0 bg-white z-40 flex flex-col items-center justify-center space-y-6">
            <button
              onClick={closeMobileMenu}
              className="absolute top-5 right-5 text-gray-700"
              aria-label="Close Menu"
            >
              <X size={26} />
            </button>

            <ul className="space-y-6 text-center">
              {navbarData.content.map(({ item, href, section }, index) => (
                <li key={index}>
                  <button
                    onClick={() => handleNavLinkClick(href, section)}
                    className="text-gray-700 text-lg font-medium hover:text-green-700 transition-all"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;








// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate, Link } from "react-router-dom";
// import { X, Menu } from "lucide-react";
// import Marquee from "react-fast-marquee";
// import { useWebData } from "../../Context/webDataContext";
// import { FaArrowRight } from "react-icons/fa";
// import LoadingScreen from "../../utils/LoadingScreen";

// function Navbar() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const { getNavbarData, isLoading } = useWebData();
//   const [navbarData, setNavbarData] = useState(null);
//   const [navbarLoader, setNavbarLoader] = useState(false);
//   const [fadeOut, setFadeOut] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setFadeOut(true);
//       setTimeout(() => {
//         setNavbarLoader(true);
//       }, 20);
//     }, 25);

//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     const fetchNavbarData = async () => {
//       try {
//         const data = await getNavbarData();
//         if (data) {
//           const navbarKey = Object.keys(data)[0];
//           setNavbarData(data[navbarKey]);
//         } else {
//           console.error("No navbar data found.");
//         }
//       } catch (error) {
//         console.error("Error fetching navbar data:", error);
//       }
//     };

//     fetchNavbarData();
//   }, [getNavbarData]);

//   useEffect(() => {
//     if (isMobileMenuOpen) {
//       document.body.classList.add("overflow-hidden");
//     } else {
//       document.body.classList.remove("overflow-hidden");
//     }
//   }, [isMobileMenuOpen]);

//   const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
//   const closeMobileMenu = () => setIsMobileMenuOpen(false);

  // const handleNavLinkClick = (href, section) => {
  //   if (href) {
  //     navigate(href.startsWith("http") ? href : `/${href}`);
  //   } else if (section) {
  //     if (location.pathname !== "/") {
  //       navigate("/");
  //       setTimeout(() => {
  //         document
  //           .getElementById(section)
  //           ?.scrollIntoView({ behavior: "smooth" });
  //       }, 50);
  //     } else {
  //       document
  //         .getElementById(section)
  //         ?.scrollIntoView({ behavior: "smooth" });
  //     }
  //   } else {
  //     navigate("/");
  //   }
  //   closeMobileMenu();
  // };

//   if (!navbarData) {
//     return (
//       <div>
//       <Marquee
//       speed={50}
//       className="md:p-4 p-2  text-center lato text-white fixed top-0"
//       style={{
//         background:
//           "linear-gradient(180deg, #1D9D67 0%, #1E8157 35.45%, #1F6546 83.28%)",
//       }}
//     >
//       <Link
//         to="/"
//         className="md:text-lg text-sm font-medium cursor-pointer flex items-center gap-1"
//       >
//         <span> New Features, Now Live! Download Now</span>

//         <span className="mt-1">
//           <FaArrowRight />
//         </span>
//       </Link>
//     </Marquee>

//     </div>
//     );
//   }


//   console.log("navbar data", navbarData);
//   return (
   
//     <nav className="w-full bg-white fixed md:static top-0 left-0 z-50 ">
//       <Marquee
//         speed={50}
//         className="md:p-4 p-2  text-center lato text-white fixed top-0"
//         style={{
//           background:
//             "linear-gradient(180deg, #1D9D67 0%, #1E8157 35.45%, #1F6546 83.28%)",
//         }}
//       >
//         <Link
//           to={navbarData.notificationContentUrl || "/"}
//           className="md:text-lg text-sm font-medium cursor-pointer flex items-center gap-1"
//         >
//           <span>{navbarData.notificationContent || "New Features, Now Live! Download Now"}</span>

//           <span className="mt-1">
//             <FaArrowRight />
//           </span>
//         </Link>
//       </Marquee>

//       <div className="px-4 lg:px-18 lg:pt-5 py-2 flex items-center justify-between">
//         {/* Logo */}
//         <Link to="/" className="text-2xl text-[#08875D] font-extrabold">
//           maid<span className="text-[#FC0]">eaze</span>
//         </Link>

//         {/* Desktop Menu */}
//         <ul className="hidden lg:flex space-x-6">
//           {navbarData.content?.map(({ item, href, section }, index) => (
//             <li key={index}>
//               <button
//                 onClick={() => handleNavLinkClick(href, section)}
//                 className="text-gray-700 hover:text-green-700 text-base font-medium hover:font-bold transition-all"
//               >
//                 {item}
//               </button>
//             </li>
//           ))}
//         </ul>

//         {/* Mobile Menu Button */}
//         <button
//           onClick={toggleMobileMenu}
//           className="lg:hidden z-50 focus:outline-none"
//           aria-label="Toggle Menu"
//         >
//           {isMobileMenuOpen ? <X size={26} /> : <Menu size={26} />}
//         </button>

//         {/* Mobile Menu Overlay */}
//         {isMobileMenuOpen && (
//           <div className="fixed inset-0 bg-white z-40 flex flex-col items-center justify-center space-y-6">
//             <button
//               onClick={closeMobileMenu}
//               className="absolute top-5 right-5 text-gray-700"
//               aria-label="Close Menu"
//             >
//               {/* <X size={26} /> */}
//             </button>

//             <ul className="space-y-6 text-center">
//               {navbarData.content?.map(({ item, href, section }, index) => (
//                 <li key={index}>
//                   <button
//                     onClick={() => handleNavLinkClick(href, section)}
//                     className="text-gray-700 text-lg font-medium hover:text-green-700 transition-all"
//                   >
//                     {item}
//                   </button>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         )}
//       </div>
//     </nav>
//   );
// }

// export default Navbar;
